import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/useUser";
import { LandingNavbar } from "../../components/landing/LandingNavbar";
import { HeroSection } from "../../components/landing/HeroSection";
import { FeaturesSection } from "../../components/landing/FeaturesSection";
import { HowItWorksSection } from "../../components/landing/HowItWorksSection";
import { CommunitySection } from "../../components/landing/CommunitySection";
import { CTASection } from "../../components/landing/CTASection";
import { Footer } from "../../components/landing/Footer";

const Index = () => {
    const { isAuthenticated } = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate("/home");
        }
    }, [isAuthenticated, navigate]);

    return (
        <div className="min-h-screen page-bg overflow-x-hidden">
            <LandingNavbar />
            <HeroSection />
            <FeaturesSection />
            <HowItWorksSection />
            <CommunitySection />
            <CTASection />
            <Footer />
        </div>
    );
};

export default Index;
